import { prop } from 'ramda'

export const reduceLevel = (place, index = 0) => {
  const placeLevel = prop(index, place.placeLevelsResume)
  if (!placeLevel) return place
  const levelId = placeLevel.levelId

  const newPlace = {
    ...place,
    ['placeLevel' + levelId]: placeLevel
  }

  return reduceLevel(newPlace, index + 1)
}
